module.exports = __webpack_public_path__ + "static/img/goldenVip.313fe41f.png";